/**
 * Created by Gaplo917 on 10/7/2017.
 */
import Rx from 'rxjs/Rx'

// singleton
class EventHub {
  constructor(){
    this.streams = {}
  }

  getEventStream(eventName){
    if(!this.streams[eventName]){
      this.streams[eventName] = new Rx.Subject()
    }

    return this.streams[eventName]
  }

  publishEvent(eventName, data){
    const stream = this.streams[eventName]
    if(stream){
      stream.next(data)
    }
  }
}

export const hub = new EventHub()
export const LOAD_COMPLETE = "LOAD_COMPLETE"
export const LOADED_FILE = "LOADED_FILE"
export const NEXT_SCENE = "NEXT_SCENE"
export const MEET_CHECKPOINT = "MEET_CHECKPOINT"
export const NO_LIFE_LEFT = "NO_LIFE_LEFT"
export const ENABLE_QUESTION_BOX = "ENABLE_QUESTION_BOX"
export const DECREASE_LIFE = "DECREASE_LIFE"
export const START_TIMER = "START_TIMER"
export const STOP_TIMER = "STOP_TIMER"
export const END_GAME = "END_GAME"

export const ANSWERED = 'ANSWERED'
export const TIMES_UP = "TIMES_UP"




// WEBPACK FOOTER //
// ./src/game/Events.js